import { Transforms, Range, Node, Editor, Element, Path } from 'slate';
import { CustomEditor, BookmarkElement } from 'slate/types/slate';
import { getAllLinks } from '../../link';

interface BookmarkRef {
  id?: string;
  path: Path;
  content: string;
}

export const insertBookmark = async (editor: CustomEditor, bookmarkId: string, label: string) => {
  if (!editor.selection || Range.isCollapsed(editor.selection)) return;
  const bookmark: BookmarkElement = {
    type: 'bookmark',
    id: bookmarkId,
    label: label,
    children: [],
  };

  Transforms.wrapNodes(editor, bookmark, { split: true });
};

export const removeBookmark = (id: string, editor: CustomEditor) => {
  const [nodeEntry] = Editor.nodes(editor, {
    match: (node) => Element.isElement(node) && node.type === 'bookmark' && node.id === id,
    at: [],
  });
  const links = getAllLinks(editor);
  const matchedLinks = links.filter((link) => link.bookmarkId === id);
  matchedLinks.forEach((link) => {
    Transforms.unwrapNodes(editor, { at: link.path });
  });
  if (!nodeEntry) return;
  Transforms.unwrapNodes(editor, { at: nodeEntry[1] });
};

export const getBookmarkById = (editor: CustomEditor, bookmarkId: string): { all: BookmarkRef[]; found: BookmarkRef | undefined } => {
  const bookmarks: BookmarkRef[] = [];

  for (const [node, path] of Node.nodes(editor, { reverse: false })) {
    if (Element.isElement(node) && node.type === 'bookmark') {
      bookmarks.push({
        id: node.id,
        path,
        content: Node.string(node),
      });
    }
  }
  return { all: bookmarks, found: bookmarks.find((bm) => bm.id === bookmarkId) };
};
